import { UpperCasePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormatDatePipe } from "../../pipes/format-date.pipe";
import { environment } from '../../../../environments/environment';
import { ChallengeResponse } from '../../interfaces/challenge-response.interface';
import { ModalService } from '../../services/modal.service';
import { ChallengeDataService } from '../../../core/services/challenge-data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChallengesTypes } from '../../enums/challenges-types.enum';

@Component({
  selector: 'app-modal-mechanics',
  imports: [UpperCasePipe, FormatDatePipe],
  templateUrl: './modal-mechanics.component.html',
  styles: ``
})
export class ModalMechanicsComponent {

  private modalService = inject(ModalService);

  private challengeData = inject(ChallengeDataService);
  private activeModal = inject(NgbActiveModal);
  apiUrl: string = environment.apiUrl + '/';
  challenge = signal<any>('');
  defaultImg = 'https://mlgdev.mx/cnvloyaltyprogramapi/photo/images/imgDefault.jpg';
  postTypes: typeof ChallengesTypes = ChallengesTypes;
  imgSrc(c: ChallengeResponse): string {
    return c.imagePath ? this.apiUrl + c.imagePath : this.defaultImg;
  }

  get isPermanent(): boolean {
    const challenge = this.challenge();

    return (
      challenge?.challengeTypeId?.toUpperCase() === this.postTypes.Permanent
    );
  }

  participate() {
    const ch = this.challenge() as ChallengeResponse;
    if (!ch?.id) return;
    this.activeModal.close();
    const ref = this.modalService.openChallengeQuiz(ch);
    ref.result
      .then((ok) => {
        if (ok === true) {
          this.challengeData.reloadChallenges();
        }
      })
      .catch(() => {
      });
  }

  close(): void {
    this.activeModal.dismiss();
  }

  canParticipate(challenge: any): boolean {
    const completed = (challenge?.status_Mechanic ?? '').toLowerCase() === 'completada';
    const isPhoto = (challenge?.challengeTypeId).toUpperCase() === this.postTypes.Image; // ajusta el campo
    const isMixed = (challenge?.challengeTypeId).toUpperCase() === this.postTypes.Mixed;
    const isPermanent = (challenge?.challengeTypeId).toUpperCase() === this.postTypes.Permanent;
    return isPhoto || isMixed || !completed || isPermanent;
  }

  Exhibicion(challenge: any): boolean {
    const isPhoto = (challenge?.challengeTypeId).toUpperCase() === this.postTypes.Image; 
    const isPermanent = (challenge?.challengeTypeId).toUpperCase() === this.postTypes.Permanent;
    return isPhoto || isPermanent;
  }
}
